import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, DialogTitle, Dialog, DialogContent, DialogActions } from '@material-ui/core';
import { Warning as WarningIcon } from '@material-ui/icons';
import { FHEContainer, FHETitle, FHEButton, FHEContainerScroll } from 'data/components';
import { Toastr } from 'data/common';
import { SvgBox } from 'data/common/iconsvg';
import { ListingBoxes, TestingBoxes, SelectBar, UserList } from './components';
import { getBoxesList } from '../../data/Boxes/actions';
import getSocketMiddlewareInstance from '../../common/SocketMiddleware';

class Boxes extends PureComponent {
    static propTypes = {
        envBox: PropTypes.string.isRequired,
        centerName: PropTypes.string.isRequired,
        middlewareState: PropTypes.string.isRequired,
        Boxes: PropTypes.object.isRequired,
        BoxesNotFetched: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        getBoxesList: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        const { envBox } = props;

        this.state = {
            loading: false,
            boxMacOnTest: false,
            warning: envBox === 'empty' ? Translator.translate(`testbench.messages.emptyEnv`) : null,
            error: null
        };
    }
    componentDidMount() {
        const socketConnexion = getSocketMiddlewareInstance();
        socketConnexion
            .on('newConnectedBoxes', this.eventNewConnectedBoxes)
            .on('disconnectedBoxes', this.eventDisconnectedBoxes)
            .on('envNotAccess', this.displayToastrErrorNotAccess);
    }

    static getDerivedStateFromProps(props, state) {
        const { warning } = state;
        const { Boxes, envBox, middlewareState, centerName } = props;
        let newWarning = null;

        if (envBox !== 'empty' && Boxes.size !== 1)
            newWarning = Translator.translate(`testbench.messages.${Boxes.size === 0 ? 'noneConnectedBoxe' : 'severalConnectedBoxes'}`, centerName);
        if (envBox === 'empty') newWarning = Translator.translate(`testbench.messages.emptyEnv`);
        if (middlewareState !== 'connected') newWarning = Translator.translate(`testbench.messages.middleDisconnected`);

        if (warning !== newWarning) return { warning: newWarning };
        return newWarning;
    }

    componentDidUpdate(prevProps, prevState) {
        const { loading, boxMacOnTest } = prevState;
        const { BoxesNotFetched, envBox } = this.props;

        if ((BoxesNotFetched.size > 0 && envBox !== 'empty' && !loading && !boxMacOnTest) || (boxMacOnTest && prevProps.envBox !== envBox)) {
            this.state.loading = true;
            this.getBoxesList();
        }
    }

    componentWillUnmount() {
        const socketConnexion = getSocketMiddlewareInstance();
        if (socketConnexion) {
            socketConnexion
                .removeListener('newConnectedBoxes', this.eventNewConnectedBoxes)
                .removeListener('disconnectedBoxes', this.eventDisconnectedBoxes)
                .removeListener('envNotAccess', this.displayToastrErrorNotAccess);
        }
    }

    eventNewConnectedBoxes = boxes => {
        const { centerName } = this.props;
        Toastr.info(Translator.translate(`testbench.messages.newBoxesConnected`, centerName, boxes.join(', ')), null, { timeOut: 1000 });
    };
    displayToastrErrorNotAccess = environment => {
        Toastr.error(
            Translator.translate(
                `testbench.messages.notAccessToEnv`,
                Translator.translate(environment === 'empty' ? 'testbench.center.title' : `${environment}.centerName`)
            )
        );
    };
    eventDisconnectedBoxes = boxes => {
        const { boxMacOnTest } = this.state;
        const { centerName, Boxes } = this.props;
        if (
            boxMacOnTest &&
            Boxes.find(Boxe => {
                return boxes.indexOf(Boxe.get('macAddress')) !== -1;
            })
        ) {
            this.setState({
                boxMacOnTest: null,
                error: Translator.translate(`testbench.messages.boxDisconnected`, centerName, boxMacOnTest.match(/.{1,2}/g).join(':'))
            });
        } else Toastr.info(Translator.translate(`testbench.messages.boxesDisconnected`, centerName, boxes.join(', ')), null, { timeOut: 1000 });
    };

    handleStateOnTest = (mac = null) => {
        this.setState({ boxMacOnTest: mac });
    };

    getBoxesList = () => {
        const { getBoxesList, BoxesNotFetched, envBox } = this.props;
        this.setState({ loading: true });
        getBoxesList(envBox, BoxesNotFetched.keySeq().toArray())
            .catch(() => {
                Toastr.error(Translator.translate(`testbench.messages.errorGetDetails`));
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    renderTest = () => {
        const { loading, boxMacOnTest } = this.state;
        const { Boxes, envBox, middlewareState } = this.props;

        return (
            <Fragment>
                {Boxes.size === 0 || (Boxes.size > 1 && !boxMacOnTest) ? (
                    <ListingBoxes Boxes={Boxes} loading={loading} env={envBox} />
                ) : (
                    <TestingBoxes
                        key={Boxes.first().get('macAddress')}
                        Box={Boxes.first()}
                        loading={loading}
                        handleStateOnTest={this.handleStateOnTest}
                        envBox={envBox}
                        disabled={middlewareState !== 'connected'}
                    />
                )}
            </Fragment>
        );
    };
    handleClose = () => {
        this.setState({ error: false });
    };
    renderError = () => {
        const { error } = this.state;
        const { classes } = this.props;

        return (
            <Dialog onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={!!error} fullWidth maxWidth="md">
                <DialogTitle id="simple-dialog-title">{Translator.translate(`testbench.messages.errorTitle`)}</DialogTitle>
                <DialogContent>
                    <div className={classes.error}>{error}</div>
                </DialogContent>
                <DialogActions>
                    <FHEButton content={Translator.translate(`testbench.buttons.continue`)} clickFunction={this.handleClose} />
                </DialogActions>
            </Dialog>
        );
    };
    renderWarning = () => {
        const { warning } = this.state;
        const { classes } = this.props;

        return (
            <div className={classes.warning}>
                <div className="d-flex align-items-center">
                    <WarningIcon color="inherit" fontSize="large" />
                    <span>{warning}</span>
                </div>
            </div>
        );
    };
    render() {
        const { warning } = this.state;
        const { centerName, middlewareState } = this.props;

        return (
            <FHEContainer>
                <SelectBar disabled={middlewareState !== 'connected'} />
                <FHETitle title={centerName} Icon={SvgBox} />
                {this.renderError()}
                {warning && this.renderWarning()}
                <FHEContainerScroll>
                    <Grid container spacing={3}>
                        <Grid container item xs={12} md={4} lg={3}>
                            <UserList />
                        </Grid>
                        <Grid container item xs={12} md={8} lg={9}>
                            {this.renderTest()}
                        </Grid>
                    </Grid>
                </FHEContainerScroll>
            </FHEContainer>
        );
    }
}

function mapStateToProps(state) {
    const Boxes = state.environments.testbench.data.Boxes.get('list');
    const BoxesNotFetched = Boxes.filter(Box => {
        return !Box.getIn(['fetched'], false);
    });
    const middlewareState = state.environments.testbench.middleware.getIn(['general', 'state'], null);
    const envBox = state.environments.testbench.data.Environments.get('active');

    return {
        envBox,
        centerName: Translator.translate(envBox === 'empty' ? 'testbench.center.title' : `${envBox}.centerName`),
        Boxes,
        BoxesNotFetched,
        middlewareState: middlewareState ? middlewareState : 'disconnected'
    };
}

const styles = theme => ({
    error: {
        color: theme.palette.warning.main,
        fontSize: 30,
        margin: 20,
        textAlign: 'center'
    },
    warning: {
        color: theme.palette.warning.main,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        fontSize: 40,
        lineHeight: 'normal',
        marginBottom: 60,
        textAlign: 'center'
    },
    title: {
        color: theme.palette.primary.main
    },
    paper: {
        backgroundColor: theme.palette.background.paper
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getBoxesList }, dispatch)
    )(withStyles(styles, { withTheme: true })(Boxes))
);



// WEBPACK FOOTER //
// ./environments/testbench/scenes/Boxes/index.js